import { ReactNode } from "react";
import { ThemeProvider } from "styled-components";

interface ThemeProps {
  children: ReactNode;
}

export const theme = {
  device: {
    screen: '1920px',
    tablet: '1024px',
    mobile: '768px',
    tiny_mobile: '500px',
  },
  deviceValues: {
    tablet: 1024,
    mobile: 768,
    tiny_mobile: 500,
  },
  colors: {
    blue: {
      dark: '#102069',
      darker: '#0f1c55',
    },
    pink: {
      light: '#f19eaf',
    },
    orange: {
      medium: '#e28732',
    },
    gray: {
      dark: '#d9d9d9',
      darker: '#969696',
      medium: '#dfdfdf',
      light: '#f7f7f7',
    },
    black: {
      light: '#5a5a5a',
      medium: '#323232',
      dark: '#24252a',
      darker: '#232429',
    },
    green: {
      light: 'rgb(97, 162, 41)',
    },
  },
};

const Theme = ({ children }: ThemeProps) => (
  <ThemeProvider theme={theme}>{children}</ThemeProvider>
);

export default Theme;